module.exports = __webpack_public_path__ + "static/media/header.73f3dfb2.png";